import { Controller } from '@hotwired/stimulus'

// Enables the submit button only when the form is touched (any input changes)
export default class extends Controller {
  static targets = ['submit']
  declare readonly submitTarget: HTMLButtonElement
  declare readonly hasSubmitTarget: boolean
  formTouched = false

  connect(): void {
    this.formTouched = false
    this.element.addEventListener('input', this.handleInput)
    this.element.addEventListener('change', this.handleInput)
  }

  handleInput = (): void => {
    if (!this.formTouched) {
      this.formTouched = true
      if (this.hasSubmitTarget) {
        this.submitTarget.classList.remove('sf-btn-disabled')
        this.submitTarget.disabled = false
      }
    }
  }
}
